import { MdPinDrop } from 'react-icons/md';
import { AircraftIcon, CarGroundIcon, HotelIcon } from '@icons';
import { LogisticsChangeLogType, SegmentTypeEnum } from '@/api/apis/route';
import { REPOSITION_SEGMENT_TYPES } from '@/utils/route';

type ChangeLogLocationIconProps = {
  logType: LogisticsChangeLogType;
  segmentType?: SegmentTypeEnum;
};

export const ChangeLogLocationIcon = ({ logType, segmentType }: ChangeLogLocationIconProps) => {
  switch (logType) {
    case LogisticsChangeLogType.TmdxJetAviaLegAddedLog:
    case LogisticsChangeLogType.TmdxJetAviaLegModifiedLog:
    case LogisticsChangeLogType.TmdxJetAviaLegRemovedLog:
    case LogisticsChangeLogType.SupplementalLiftAviaLegAddedLog:
    case LogisticsChangeLogType.SupplementalLiftAviaLegModifiedLog:
    case LogisticsChangeLogType.SupplementalLiftAviaLegRemovedLog:
    case LogisticsChangeLogType.TxCenterProviderAviaLegAddedLog:
    case LogisticsChangeLogType.TxCenterProviderAviaLegModifiedLog:
    case LogisticsChangeLogType.TxCenterProviderAviaLegRemovedLog:
    case LogisticsChangeLogType.CommercialFlightAviaLegAddedLog:
    case LogisticsChangeLogType.CommercialFlightAviaLegModifiedLog:
    case LogisticsChangeLogType.CommercialFlightAviaLegRemovedLog:
      const isRepositionSegment = segmentType && REPOSITION_SEGMENT_TYPES.includes(segmentType);

      if (isRepositionSegment) {
        return (
          <div className="flex gap-0.5 items-center">
            <span className="text-xs-m text-white px-1 py-0.5 flex justify-center items-center bg-black rounded-full">
              REP
            </span>
            <AircraftIcon />
          </div>
        );
      }

      return <AircraftIcon />;
    case LogisticsChangeLogType.TmdxAffiliateGroundLegAddedLog:
    case LogisticsChangeLogType.TmdxAffiliateGroundLegModifiedLog:
    case LogisticsChangeLogType.TmdxAffiliateGroundLegRemovedLog:
    case LogisticsChangeLogType.TxCenterProviderGroundLegAddedLog:
    case LogisticsChangeLogType.TxCenterProviderGroundLegModifiedLog:
    case LogisticsChangeLogType.TxCenterProviderGroundLegRemovedLog:
    case LogisticsChangeLogType.CurriServiceGroundLegAddedLog:
    case LogisticsChangeLogType.CurriServiceGroundLegModifiedLog:
    case LogisticsChangeLogType.CurriServiceGroundLegRemovedLog:
    case LogisticsChangeLogType.TmdxDriveAffiliateGroundLegAddedLog:
    case LogisticsChangeLogType.TmdxDriveAffiliateGroundLegModifiedLog:
    case LogisticsChangeLogType.TmdxDriveAffiliateGroundLegRemovedLog:
    case LogisticsChangeLogType.TmdxDriveTedsGroundLegAddedLog:
    case LogisticsChangeLogType.TmdxDriveTedsGroundLegModifiedLog:
    case LogisticsChangeLogType.TmdxDriveTedsGroundLegRemovedLog:
    case LogisticsChangeLogType.SelfServicedGroundLegAddedLog:
    case LogisticsChangeLogType.SelfServicedGroundLegModifiedLog:
    case LogisticsChangeLogType.SelfServicedGroundLegRemovedLog:
    case LogisticsChangeLogType.GroundTripToAffiliateLegAssignedLog:
    case LogisticsChangeLogType.GroundTripToTedsLegAssignedLog:
    case LogisticsChangeLogType.GroundTripToAffiliateLegReassignedLog:
    case LogisticsChangeLogType.GroundTripToTedsLegReassignedLog:
      return <CarGroundIcon />;
    case LogisticsChangeLogType.RouteDepartureHubAssignedLog:
    case LogisticsChangeLogType.RouteDepartureHubUnassignedLog:
    case LogisticsChangeLogType.RouteArrivalHubAssignedLog:
    case LogisticsChangeLogType.RouteArrivalHubUnassignedLog:
      return <MdPinDrop size={16} />;
    case LogisticsChangeLogType.AccommodationLegAddedLog:
    case LogisticsChangeLogType.AccommodationLegModifiedLog:
    case LogisticsChangeLogType.AccommodationLegRemovedLog:
    default:
      return <HotelIcon />;
  }
};
